export default "__VITE_ASSET__Ep8_Jg1Z__"